const trackCustom = (name, payload) => {
  window.fbq('trackCustom', name, payload)
}

const init = (trackingCode) => {
  window.fbq('init', trackingCode)
}

const pageView = () => {
  window.fbq('track', 'PageView')
}

export default {
  init,
  pageView,
  trackCustom
}
